import { get, ref, set } from 'firebase/database';
import { Session } from '../../Models/session';
import { database } from '../firebase';

export const addPersonToSession: (
    personId: string,
    sessionId: string,
) => Promise<void> = async (personId, sessionId) => {
    try {
        const session = await get(ref(database, `sessions/${sessionId}`));

        if (session) {
            const sessionVal: Session = session.val();

            if (
                sessionVal.people &&
                Object.keys(sessionVal.people).includes(personId)
            ) {
                throw Error('This person already is in the session');
            }

            set(
                ref(database, `sessions/${sessionId}/people/${personId}`),
                true,
            );
        }
    } catch (err) {
        throw err;
    }

    return;
};
